import { ChangeDetectionStrategy, Component, NgZone } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Browser } from '@capacitor/browser';
import { downloadApk } from '@ildes/utils/download-apk';
import { installApk } from '../../../plugins/update-manager';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { ToastService } from '@ildes/services/toast.service';

const url = 'https://ildes.co/assets/app-release.apk';
@Component({
  selector: 'app-popups-notifications-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatProgressBarModule,
    CommonModule
  ],
  template: `
  <h2>Existe una una nueva actualización</h2>
  <p></p>
  <div class="padding-top-8 padding-bottom-8">
    <mat-progress-bar mode="determinate" [value]="progress" *ngIf="loading"></mat-progress-bar>
  </div>
  <button [disabled]="loading" (click)="download()" color="primary" mat-button class="btn-menu">
    Descargar
  </button>

  `,
  styleUrls: ['./popups-notifications-dialog.component.css']
})
export class PopupsNotificationsDialogComponent {

    constructor(
        private zone: NgZone,
        private toast: ToastService,
    ) {

    }
    progress = 0;
    loading = false;
    async download() {
        this.loading = true;
        let path;
        this.progress = 0;
        try {
            path = await downloadApk(url, (progress) => {
                this.zone.run(() => {
                    this.progress = Math.round((progress.bytes / progress.contentLength) * 100);
                })
            });
        } catch {

        }
        
        this.loading = false;

        if (!path) {
            return;
        }
        try {
            await installApk(path);
        } catch {
            this.toast.show('No se pudo actualizar la app', 'error');
        }
    }
}
